/* If you edit this file, please remove this header and clean up the resulting eslint errors.
*/
/* eslint-disable
  import/no-commonjs,
  func-names,
  no-continue,
  no-void
*/
import fieldIsVisible from './field-visible';
import DOMHelper from './dom-helper';

const MAX_DST = 10; // in pixels


//  ----  HELPERS  ----------------------------------------

const distance = function (p1, p2) {
  const dx = p2.x - p1.x;
  const dy = p2.y - p1.y;
  return Math.sqrt(dx * dx + dy * dy);
};

const getFieldCenterPoint = function (field, zoom, containerOffset) {
  return {
    x: (field.x + containerOffset.x + field.width / 2) * zoom,
    y: (field.y + containerOffset.y + field.height / 2) * zoom,
  };
};

const getFieldRadius = function (field, zoom) {
  const r = field.width / 2;
  return r * Math.sqrt(2) * zoom;
};

const getContainerOffset = function (evt, zoom) {
  const parent = evt.currentTarget.parentNode;
  const rect = DOMHelper.getBoundingClientRectForZoom(parent, zoom);
  return {
    x: rect.left,
    y: rect.top,
  };
};

//  ----  PUBLIC METHODS  ---------------------------------

/**
 * Find the checkbox nearest to a click event
 */
const findNearest = function (evt, app, fields) {

  const isFocusable = (evt.target.getAttribute('data-focus') === 'true');

  if (isFocusable || !fields || !fields.length) {
    // Nothing to do then, let's just ignore this event
    return void 0;
  }

  const docInner = document.getElementsByClassName('m-signature-document--inner')[0];
  const zoom = parseFloat(docInner.style.zoom, 10) / 100;
  const containerOffset = getContainerOffset(evt, zoom);
  const point = {
    x: evt.pageX,
    y: evt.pageY,
  };

  const maxDistance = MAX_DST * zoom; // NOTE: The max distance shrinks as you zoom in
  let minDistance = 99999;
  let minIndex = -1;

  // TODO - accessing view-specific property here. get this property elsewhere such as a global
  // DS store or similar. (CC)
  const bounds = app.signatureRequest.bounds;

  for (let i = 0; i < fields.length; i++) {

    const field = fields[i];

    if (!fieldIsVisible(field, bounds, zoom)) {
      continue;
    }

    const radius = getFieldRadius(field, zoom);
    const center = getFieldCenterPoint(field, zoom, containerOffset);
    const d = distance(point, center);

    if (d - radius > maxDistance) {
      continue;
    }

    if (d < minDistance) {
      minDistance = d;
      minIndex = i;
    }
  }

  if (minIndex >= 0) {
    evt.preventDefault();
    evt.stopPropagation();
  }

  return fields[minIndex];
};

/**
 * Toggle a given checkbox
 */
const toggle = function (app, field) {
  if (field) {

    // Toggle the checkbox
    field.setValue(field.value ? void 0 : true);
    field.signatureRequest.save();

    // Focus when necessary
    if (app) {

      const newCurrentField = (field.hasGroup() ? field.group : field);

      if (!newCurrentField.equals(app.location.state.currentField)) {
        app.router.redirect('signNext', {
          params: {
            field: newCurrentField,
          },
          query: {
            validate: app.location.state.validate,
          },
        });
      }
    }
  }
};

module.exports = {
  findNearest,
  toggle,
};
